

import * as domtoimage from 'dom-to-image';



document.querySelector('.btn-submit').addEventListener('click', function (e) {
    e.preventDefault();

    // const textarea = document.querySelector('textarea');
    // const preview = document.querySelector('.preview-text');
    // const card = document.getElementById('card');

    // // Gán nội dung textarea vào preview
    // const text = textarea.value;
    // preview.textContent = text;

    // // Hiện preview, ẩn textarea
    // preview.style.display = 'block';
    // textarea.style.display = 'none';

    // Chụp ảnh với bộ lọc bỏ các phần tử có class không liên quan (ví dụ fancybox gây lỗi)
    domtoimage.toPng(card, {
     filter: (node) => {
  if (node.tagName === 'LINK') return false;
  if (node.className && typeof node.className === 'string') {
    return !node.className.includes('fancybox'); // hoặc 'libraryMainsite'
  }
  return true;
}
    }).then(function (dataUrl) {
      // Tạo và tải ảnh
      const link = document.createElement('a');
      link.download = 'thiep-chuc-mung.png';
      link.href = dataUrl;
      link.click();

      // Khôi phục lại textarea
      // preview.style.display = 'none';
      // textarea.style.display = 'block';
    }).catch(function (error) {
      console.error('Lỗi khi tạo ảnh:', error);
      // Trong mọi trường hợp lỗi, vẫn khôi phục textarea
      // preview.style.display = 'none';
      // textarea.style.display = 'block';
    });
  });
// Xử lý click btn-luuthiep để chuyển từ popup_taiAnh sang popup_save
$(document).ready(function() {
  $('.btn-luuthiep').on('click', function(e) {
    e.preventDefault();
    
    // Lấy dữ liệu từ popup_taiAnh
    const $popupTaiAnh = $('#popup_taiAnh');
    const $popupSave = $('#popup_save');
    
 
    // Remove active từ popup_taiAnh
    $popupTaiAnh.removeClass('active');
    
    // Thêm active vào popup_save
    $popupSave.addClass('active');
  });
});